import { render, staticRenderFns } from "./formulaDet.vue?vue&type=template&id=5843291e&scoped=true&"
import script from "./formulaDet.vue?vue&type=script&lang=js&"
export * from "./formulaDet.vue?vue&type=script&lang=js&"
import style0 from "./formulaDet.vue?vue&type=style&index=0&id=5843291e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843291e",
  null
  
)

export default component.exports